module.exports = __webpack_public_path__ + "img/3-3.9734e19c.svg";